import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import FullScreenLoader from "./FullScreenLoader";
import Swal from 'sweetalert2'


const ViewOrderStatus = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.loginUser);
  const BASE_URl = window.location.origin

  const fetchOrders = useCallback(()=>{
    if (!user) {
      toast.error("Login To View Your Orders");
      navigate("/");
    } else {
      fetch(`${BASE_URl}/api/viewOrders/${user._id}`, {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          setData(data.orders || []);
        })
        .catch((error) => {
          toast.error(error.message || "Something Went Wrong");
        })
        .finally(() => setLoading(false));
    }
  },[navigate, user, BASE_URl])

  useEffect(() => {
    fetchOrders()
  });

  const handleCancleOrder = async(id) => {
    const formData = {
      userId: user._id
    }
    const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Do You Want To Cancle The Order",
        });

        if(result.isConfirmed){
          setLoading(true)
          fetch(`${BASE_URl}/api/cancleOrder/${id}`, {
            method: "POST",
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          }).then((res) => res.json())
          .then((data) => {
            if(data && data.sucess === true){
              fetchOrders()
              setLoading(false)
              toast.success(data.messege)
            } else if(data && data.sucess === false){
              setLoading(false)
              toast.error(data.messege)
            }
          }).catch((error) => {
            setLoading(false)
            toast.error(error.messege || 'something went wrong')
          })
        }
  }

  return (
    <div className="mt-16 px-4">
      <h1 className="text-center text-2xl font-bold text-gray-800 mb-4">
        Your Orders
      </h1>

      {loading ? (
        <FullScreenLoader/>
      ) : data.length === 0 ? (
        <p className="text-center text-gray-500">No orders found.</p>
      ) : (
        <div className="max-w-3xl mx-auto space-y-4">
          {data
            .slice()
            .reverse()
            .map((order) => (
              <div
                key={order._id}
                className="bg-white shadow-md rounded-lg p-4 flex flex-col sm:flex-row items-center sm:items-start space-y-3 sm:space-y-0 sm:space-x-4"
              >
                {/* Order Image */}
                <img
                  src={order.item?.image?.secure_url}
                  alt={order.item?.title}
                  className="w-24 h-24 object-cover rounded-md"
                />

                {/* Order Details */}
                <div className="flex-1">
                  <h3 className="text-lg font-semibold">{order.item?.title}</h3>
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold">Status:</span> {order.status}
                  </p>
                  <p className="text-sm text-gray-600">
                    <span className="font-semibold">Address:</span> {order.adress}
                  </p>
                </div>

                {order.isCancled !== true ? <button
                  onClick={()=>{handleCancleOrder(order._id)}}
                    className="cursor-pointer px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                  >
                    Cancel Order
                  </button>:<p className="bg-red-500 text-white p-1.5 rounded-[9px]">Order Cancelled</p>}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default ViewOrderStatus;
